import React from 'react';
import { LoginContainer } from '../../containers';

const LoginPage = () => <LoginContainer />;

export default LoginPage;
